/** @prettier */
import { DIGITAL_CONTENT } from '@site-builder/common/src/utils/store';

import {
  sortArrayAlphabetically,
  removeDuplicates,
  filterArray,
} from '../../utils/array-helper';
import { detectDevice } from '../../utils/common-helper';
import { handleGameKey } from '../actions/buyGameKeys';

const retailersTranslations = (translations) => {
  const TITLE = '.retailers__option-title';
  const elements = [
    [`.retailers__edition ${TITLE}`, 'client.retailers.edition.title'],
    [
      ".retailers__edition [data-edition='Digital']",
      'client.retailers.edition.digital',
    ],
    [
      ".retailers__edition [data-edition='Physical']",
      'client.retailers.edition.physical',
    ],
    [`.retailers__country ${TITLE}`, 'client.retailers.country.title'],
    [`.retailers__platform ${TITLE}`, 'client.retailers.platform.title'],
    [`.retailers__retailer ${TITLE}`, 'client.retailers.retailer.title'],
    [
      '.retailers__expanded-button-text span',
      'client.retailers.buy_button.buy',
    ],
    ['.retailers__link-button', 'client.retailers.buy_button.buy'],
  ];

  elements.forEach(([selector, translationsLabel]) => {
    document.querySelector(selector).innerHTML =
      // eslint-disable-next-line security/detect-object-injection
      translations[translationsLabel];
  });
};

export default ({ data, translations }) =>
  import('jquery').then(
    /**
     * Jquery ($) is @deprecated, use native API instead
     */
    ({ default: $ }) => {
      const { retailersData } = data;

      retailersTranslations(translations);

      const XSOLLA_RETAILER = 'Buy from Developer';

      const ACTIVE_CLASS = 'retailers__list-item--active';
      const NO_ACTIVE_CLASS = 'retailers__list-item--inactive';
      const HIDDEN_CLASS = 'retailers__buttons--hide';
      const EXPANDED_CLASS = 'retailers__dropdown-list--expanded';
      const SINGLE_CLASS = 'retailers__selector--single';
      const CLICKED_CLASS = 'retailers__expanded-button--clicked';

      const DESKTOP_SELECTOR = '.retailers__selector--desktop';
      const MOBILE_SELECTOR = '.retailers__selector--mobile';

      const EDITION_LABEL = '#edition_label';
      const COUNTRY_LABEL = '#country_label';
      const PLATFORM_LABEL = '#platform_label';
      const RETAILER_LABEL = '#retailer_label';

      const AVAILABLE_COLUMNS_NAMES = [
        'edition',
        'country',
        'platform',
        'retailer',
        'link',
        'pack',
      ];
      const AVAILABLE_EDITIONS = ['Digital', 'Physical'];
      const AVAILABLE_PLATFORMS = [
        'EPIC GAMES',
        'GOG',
        'PC',
        'PS4',
        'PS5',
        'SWITCH',
        'XBOX ONE',
        'XBOX SX',
      ];
      const PLATFORMS_MAP = {
        'EPIC GAMES': 'Epic Games Store',
        GOG: 'GOG',
        PC: 'PC',
        PS4: 'PlayStation 4',
        PS5: 'PlayStation 5',
        SWITCH: 'Nintendo Switch',
        'XBOX ONE': 'Xbox One',
        'XBOX SX': 'Xbox Series S|X',
      };

      $('.retailers__expanded-button').click(function clickOnExpandButton() {
        $(this).toggleClass(CLICKED_CLASS);
        $(this).next().toggleClass('retailers__main-content--hide');

        if ($(this).hasClass(CLICKED_CLASS)) {
          $(this)
            .find('span')
            .text(translations['client.retailers.expand_button.collapse']);
        } else {
          $(this)
            .find('span')
            .text(translations['client.retailers.buy_button.buy']);
        }
      });

      $(document).click((e) => {
        const targetEl = e.target;
        const selectors = [
          'retailers__selector--desktop',
          'retailers__country-title',
          'retailers__platform-title',
          'retailers__retailer-title',
        ];

        if (
          selectors.some((className) => targetEl.classList.contains(className))
        ) {
          const dropdownList =
            $(targetEl).find('.retailers__dropdown-list').length > 0
              ? $(targetEl).find('.retailers__dropdown-list')
              : $(targetEl).siblings('.retailers__dropdown-list');

          if (dropdownList.hasClass(EXPANDED_CLASS)) {
            return dropdownList.removeClass(EXPANDED_CLASS);
          }

          $('.retailers__dropdown-list').removeClass(EXPANDED_CLASS);
          return dropdownList.addClass(EXPANDED_CLASS);
        }

        return $('.retailers__dropdown-list').removeClass(EXPANDED_CLASS);
      });

      if (detectDevice()) {
        $(DESKTOP_SELECTOR).remove();
        $(MOBILE_SELECTOR).show();
      } else {
        $(DESKTOP_SELECTOR).show();
        $(MOBILE_SELECTOR).remove();
      }

      const generatePurchase = (buyButton) => {
        buyButton.targetElements.forEach((target) => {
          handleGameKey({
            data,
            gameKey: {
              projectId: buyButton.projectId,
              sku: buyButton.sku,
              drm: buyButton.drm,
              target,
              type: buyButton.type || DIGITAL_CONTENT,
            },
          });
        });
      };

      const jsonErrorHandler = (json) => {
        const errors = [];

        const firstRecordKeys = Object.keys(json[0]);
        firstRecordKeys.forEach((el, index) => {
          if (!AVAILABLE_COLUMNS_NAMES.includes(el)) {
            errors[index] = {
              subject: el,
              index,
              object: `Invalid column name. Should be "${AVAILABLE_COLUMNS_NAMES[index]}"`,
            };
          }
        });

        json.forEach((el, index) => {
          if (!AVAILABLE_EDITIONS.includes(el.edition)) {
            errors[index] = {
              subject: el.edition,
              index,
              object: JSON.stringify(el),
            };
          }

          el.platform.forEach((platform) => {
            if (!AVAILABLE_PLATFORMS.includes(platform)) {
              errors[index] = {
                subject: el.platform,
                index,
                object: JSON.stringify(el),
              };
            }
          });
        });

        if (errors.length > 0) {
          throw Object(errors);
        }
      };

      const textsMapping = (key) => {
        switch (key) {
          case 'Digital':
            return translations['client.retailers.edition.digital'];
          case 'Physical':
            return translations['client.retailers.edition.physical'];
          case 'Buy from Developer':
            return translations['client.retailers.retailer.default_retailer'];
          default:
            return false;
        }
      };

      class RetailersPack {
        constructor(data) {
          this.edition = data.edition;
          this.country = data.country;
          this.platform = data.platform;
          this.retailer = data.retailer;
          this.link = data.link;
          this.retailersList = data.retailersList;
          this.packElement = data.packElement;
          this.sortedData = data.sortedData;
        }

        updateBreadcrumbs() {
          this.packElement.find(EDITION_LABEL).text(textsMapping(this.edition));
          this.packElement.find(COUNTRY_LABEL).text(this.country);
          this.packElement.find(PLATFORM_LABEL).text(this.platform);
          this.packElement
            .find(RETAILER_LABEL)
            .text(
              this.retailer === XSOLLA_RETAILER
                ? textsMapping(this.retailer)
                : this.retailer
            );
        }

        setInitialData() {
          this.updatePackState([
            'defaultEditions',
            'countries',
            'platforms',
            'retailers',
          ]);

          this.packElement
            .find('.retailers__platform .retailers__list-item')
            .removeClass(ACTIVE_CLASS);
        }

        updateDefaultEditions() {
          const filteredData = removeDuplicates(this.sortedData, 'edition');

          this.packElement
            .find('.retailers__edition .retailers__list-item')
            .removeClass(`${ACTIVE_CLASS} ${NO_ACTIVE_CLASS}`);

          AVAILABLE_EDITIONS.forEach((edition) => {
            if (!filteredData.some((data) => data.edition === edition)) {
              this.packElement.find(`[data-edition='${edition}']`).remove();
            }
          });

          this.packElement
            .find(`[data-edition=${this.edition}]`)
            .addClass(ACTIVE_CLASS);
        }

        updateEditions(filters) {
          const filteredData = filterArray(this.sortedData, filters);

          this.packElement
            .find('.retailers__edition .retailers__list-item')
            .removeClass(`${ACTIVE_CLASS} ${NO_ACTIVE_CLASS}`);
          AVAILABLE_EDITIONS.forEach((edition) => {
            if (!filteredData.some((data) => data.edition === edition)) {
              return this.packElement
                .find(`[data-edition='${edition}']`)
                .remove();
            }

            return this.packElement
              .find(`[data-edition='${this.edition}']`)
              .addClass(ACTIVE_CLASS);
          });
        }

        updateCountries(filters) {
          const filteredData = filterArray(this.sortedData, filters);
          const countiesForEdition = [];

          const countryNode = this.packElement.find('.retailers__country');
          countryNode.find('.retailers__dropdown-item').remove();

          const uniqCountries = removeDuplicates(filteredData, 'country');
          uniqCountries.forEach((el) => {
            countiesForEdition.push(el.country);
            countryNode
              .find('.retailers__dropdown-list')
              .append(
                `<div class="retailers__dropdown-item">${el.country}</div>`
              );
            countryNode
              .find(`${MOBILE_SELECTOR} .retailers__selector`)
              .append(
                `<option class="retailers__dropdown-item">${el.country}</option>`
              );
          });

          const newCountry = countiesForEdition[0];
          if (!countiesForEdition.includes(this.country)) {
            this.country = newCountry;
          }
          this.packElement.find('.retailers__country-title').text(this.country);

          if (uniqCountries.length === 1) {
            countryNode.find('.retailers__selector').addClass(SINGLE_CLASS);
            countryNode.find(MOBILE_SELECTOR).addClass(SINGLE_CLASS);
          } else {
            countryNode.find('.retailers__selector').removeClass(SINGLE_CLASS);
            countryNode.find(MOBILE_SELECTOR).removeClass(SINGLE_CLASS);
          }
        }

        updatePlatforms(filters) {
          const filteredData = filterArray(this.sortedData, filters);
          const platformsForEdition = [];
          const allPlatforms = [
            ...new Set(filteredData.flatMap((data) => [...data.platform])),
          ];

          const platformNode = this.packElement.find('.retailers__platform');
          platformNode.find('.retailers__dropdown-item').remove();

          allPlatforms.forEach((platform) => {
            platformsForEdition.push(platform);
            platformNode
              .find('.retailers__dropdown-list')
              .append(
                `<div class="retailers__dropdown-item" data-platform="${platform}">${PLATFORMS_MAP[platform]}</div>`
              );
            platformNode
              .find(`${MOBILE_SELECTOR} .retailers__selector`)
              .append(
                `<option data-platform="${platform}" class="retailers__dropdown-item">${platform}</option>`
              );
          });

          const newPlatform = platformsForEdition[0];
          if (!platformsForEdition.includes(this.platform)) {
            this.platform = newPlatform;
          }
          this.packElement
            .find('.retailers__platform-title')
            .text(this.platform);

          if (allPlatforms.length === 1) {
            platformNode.find('.retailers__selector').addClass(SINGLE_CLASS);
            platformNode.find(MOBILE_SELECTOR).addClass(SINGLE_CLASS);
          } else {
            platformNode.find('.retailers__selector').removeClass(SINGLE_CLASS);
            platformNode.find(MOBILE_SELECTOR).removeClass(SINGLE_CLASS);
          }
        }

        updateRetailers(filters) {
          const filteredData = filterArray(this.sortedData, filters);

          filteredData.sort((ret1, ret2) => {
            if (ret1.retailer === XSOLLA_RETAILER) {
              return -1;
            }
            if (ret2.retailer === XSOLLA_RETAILER) {
              return 1;
            }
            return 0;
          });

          const retailerNode = this.packElement.find('.retailers__retailer');
          retailerNode.find('.retailers__dropdown-item').remove();

          this.retailersList = [];
          filteredData.forEach((el) => {
            const itemText =
              el.retailer === XSOLLA_RETAILER
                ? textsMapping(el.retailer)
                : el.retailer;
            retailerNode
              .find('.retailers__dropdown-list')
              .append(
                `<div data-retailer='${el.retailer}' class="retailers__dropdown-item">${itemText}</div>`
              );
            retailerNode
              .find(`${MOBILE_SELECTOR} .retailers__selector`)
              .append(
                `<option data-retailer='${el.retailer}' class="retailers__dropdown-item">${itemText}</option>`
              );
            this.retailersList.push(el.retailer);
          });

          this.link = filteredData[0].link;
          this.retailer = filteredData[0].retailer;
          this.packElement
            .find('.retailers__retailer-title')
            .text(
              this.retailer === XSOLLA_RETAILER
                ? textsMapping(this.retailer)
                : this.retailer
            );

          if (filteredData.length === 1) {
            retailerNode.find('.retailers__selector').addClass(SINGLE_CLASS);
            retailerNode.find(MOBILE_SELECTOR).addClass(SINGLE_CLASS);
          } else {
            retailerNode.find('.retailers__selector').removeClass(SINGLE_CLASS);
            retailerNode.find(MOBILE_SELECTOR).removeClass(SINGLE_CLASS);
          }

          this.updateButtons();
        }

        updateButtons() {
          const filters = {
            edition: [this.edition],
            country: [this.country],
            platform: [this.platform],
          };

          const filteredData = filterArray(this.sortedData, filters);
          const currentRetailer = filteredData.find(
            (el) => el.retailer === this.retailer
          );

          this.packElement
            .find('.retailers__link-button')
            .addClass(HIDDEN_CLASS);
          this.packElement
            .find('.retailers__buy-button')
            .addClass(HIDDEN_CLASS);

          if (this.retailer !== XSOLLA_RETAILER) {
            this.packElement
              .find('.retailers__link-button')
              .removeClass(HIDDEN_CLASS)
              .attr('href', currentRetailer.link);
          } else {
            const currentEdition = this.edition
              .toLowerCase()
              .replace(/\s/g, '');
            const currentPlatform = this.platform
              .toLowerCase()
              .replace(/\s/g, '');

            const packId = this.packElement.attr('id');
            const p2pButton = $(
              `#XS-pay2play-widget-${currentEdition}-${currentPlatform}-${packId}`
            );
            p2pButton.removeClass(HIDDEN_CLASS);
          }

          this.updateBreadcrumbs();
        }

        updatePackState(keys = []) {
          keys.forEach((el) => {
            const editionsFilter = {
              country: [this.country],
            };
            const countiesFilter = {
              edition: [this.edition],
            };
            const platformsFilter = {
              edition: [this.edition],
              country: [this.country],
            };
            const retailersFilter = {
              edition: [this.edition],
              country: [this.country],
              platform: [this.platform],
            };

            switch (el) {
              case 'defaultEditions':
                this.updateDefaultEditions();
                break;
              case 'editions':
                this.updateEditions(editionsFilter);
                break;
              case 'countries':
                this.updateCountries(countiesFilter);
                break;
              case 'platforms':
                this.updatePlatforms(platformsFilter);
                break;
              case 'retailers':
                this.updateRetailers(retailersFilter);
                break;
              default:
                break;
            }

            return true;
          });
        }

        changeEdition() {
          this.packElement
            .find('.retailers__edition .retailers__list-item')
            .click((e) => {
              this.edition = e.currentTarget.getAttribute('data-edition');
              this.packElement
                .find('.retailers__edition .retailers__list-item')
                .removeClass(ACTIVE_CLASS);
              $(e.currentTarget).addClass(ACTIVE_CLASS);

              this.updatePackState(['countries', 'platforms', 'retailers']);
            });
        }

        changeCounty() {
          this.packElement.on(
            'click',
            '.retailers__country .retailers__dropdown-item',
            (e) => {
              this.country = $(e.currentTarget).text();
              this.packElement
                .find('.retailers__country-title')
                .text(this.country);

              this.updatePackState(['platforms', 'retailers']);
            }
          );

          this.packElement.on(
            'change',
            `.retailers__country ${MOBILE_SELECTOR} .retailers__selector`,
            (e) => {
              this.country = $(e.currentTarget).find('option:selected').text();

              this.updatePackState(['platforms', 'retailers']);
            }
          );
        }

        changePlatform() {
          this.packElement.on(
            'click',
            '.retailers__platform .retailers__dropdown-item',
            (e) => {
              this.platform = $(e.currentTarget).attr('data-platform');
              this.packElement
                .find('.retailers__platform-title')
                .text($(e.currentTarget).text());

              this.updatePackState(['retailers']);
            }
          );

          this.packElement.on(
            'change',
            `.retailers__platform ${MOBILE_SELECTOR} .retailers__selector`,
            (e) => {
              this.platform = $(e.currentTarget)
                .find('option:selected')
                .attr('data-platform');

              this.updatePackState(['retailers']);
            }
          );
        }

        changeRetailer() {
          this.packElement.on(
            'click',
            '.retailers__retailer .retailers__dropdown-item',
            (e) => {
              this.retailer = $(e.currentTarget).attr('data-retailer');
              this.packElement
                .find('.retailers__retailer-title')
                .text(
                  this.retailer === XSOLLA_RETAILER
                    ? textsMapping(this.retailer)
                    : this.retailer
                );

              this.updateButtons();
            }
          );

          this.packElement.on(
            'change',
            `.retailers__retailer ${MOBILE_SELECTOR} .retailers__selector`,
            (e) => {
              this.retailer = $(e.currentTarget).find('option:selected').text();

              this.updateButtons();
            }
          );
        }

        prepareRetailersPack() {
          this.setInitialData();
          this.changeEdition();
          this.changeCounty();
          this.changePlatform();
          this.changeRetailer();
        }
      }

      jsonErrorHandler(retailersData);
      const sortedData = sortArrayAlphabetically(retailersData, 'country');

      removeDuplicates(sortedData, 'pack').forEach((el) => {
        const filters = {
          pack: [el.pack],
        };

        const initialValue = {
          edition: el.edition,
          country: el.country,
          platform: el.platform[0],
          retailer: el.retailer,
          link: el.link,
          retailersList: [],
          packElement: $(`#${el.pack}`),
          sortedData: filterArray(sortedData, filters),
        };

        if (window.RETAILERS_BUY_BUTTONS) {
          const currentPack =
            window.RETAILERS_BUY_BUTTONS[initialValue.packElement.attr('id')];
          if (currentPack) {
            currentPack.forEach((buyButton) => {
              buyButton.targetElements.forEach((target) => {
                initialValue.packElement
                  .find('.retailers__buttons')
                  .append(
                    `<div id="${target.substr(
                      1
                    )}" class="retailers__buy-button ${HIDDEN_CLASS}"></div>`
                  );
              });

              generatePurchase(buyButton);
            });
          }
        }

        const pack = new RetailersPack(initialValue);
        pack.prepareRetailersPack();
      });
    }
  );
